module.exports = __webpack_public_path__ + "static/media/check_yellow.dbc2f07e.svg";